
export const getValueFromLocalStorage = (key: string) => {
    const item = localStorage.getItem(key);
    if (item) {
        return JSON.parse(item)
    }
    return;
}

export const setValueToLocalStorage = (key: string, value: string) => {
    localStorage.setItem(key, JSON.stringify(value))
}

export const removeValueFromLocalStorage = (key: string) => {
    localStorage.removeItem(key)
}